import type { NormalizedCacheObject } from "@apollo/client";
import { createContext, useContext } from "react";

interface SSRData {
  initialApolloState: NormalizedCacheObject;
  initialProps: any;
}

const DefaultSSRData: SSRData = {
  initialApolloState: {},
  initialProps: {},
};

const useSSRContext = (): SSRData => {
  const ssrData: SSRData = useContext(SSRContext);

  return ssrData;
};

const SSRContext = createContext<SSRData>(DefaultSSRData);

export type { SSRData };
export { SSRContext, useSSRContext, DefaultSSRData };
